//
// Helper/Wrap around local storage
// All values are stored as objects
//

const isWeb = typeof window !== "undefined"

export const setObject = (key, val) => {
  if (!isWeb) return {}
  const currentObject = getObject(key)
  localStorage.setItem(key, JSON.stringify({ ...currentObject, ...val }))
}

export const getObject = key => {
  if (!isWeb) return {}
  const val = localStorage.getItem(key) || "{}"
  return JSON.parse(val)
}

export const removeObject = key => {
  if (!isWeb) return {}
  localStorage.removeItem(key)
}
